<template>
  <div
    class="ui-tabs"
    :class="[
      props.direction ? 'ui-tabs--' + props.direction : '',
      props.type ? 'ui-tabs--' + props.type : '',
    ]"
  >
    <ul
      class="ui-tabs__nav"
      :class="{'hide-mobile': isSelectInMobile}"
    >
      <li
        v-for="tab in tabs"
        :key="tab.computedId"
        class="btn-text"
        :class="[
          'ui-tabs__tab',
          tab.isDisabled ? 'is-disabled' : '',
          tab.isActive ? 'is-active' : '',
        ]"
        @click="
          () => {
            selectTab(tab.computedId);
          }
        "
      >
        {{ tab.header }}
      </li>
    </ul>
    <ui-select
      v-if="isSelectInMobile"
      v-model="selectModel"
      class="ui-tabs__select"
      :return-object="true"
      :options="selectOption"
      @change="selectTab($event.id)"
    />
    <div class="ui-tabs__panel">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useTabs} from '~/hooks/ui/useTabs';
import UiSelect from '~/components/Ui/UiSelect.vue';
import {computed, ref} from '#imports';

type Props = {
  direction?: string;
  type?: string;
  isSelectInMobile?: boolean;
  anchor?: string;
};

const props = defineProps<Props>();

const emits = defineEmits(['changed', 'clicked', 'beforeChange']);
const {tabs, selectTab, activeTabId} = useTabs(emits);

const selectModel = ref(activeTabId);
const selectOption = computed(() =>
  tabs.value.map((tab) => ({
    id: tab.computedId,
    value: tab.name,
    text: tab.name,
    selected: false,
  })),
);

// if (props.anchor) {
//   selectTab(props.anchor)
// }
</script>

<style scoped lang="scss">
.ui-tabs {
  &__nav {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    position: relative;
    overflow: auto;
    align-self: stretch;
    align-items: center;
    flex-wrap: nowrap;
    display: flex;
    flex: 1 1 auto;
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-bottom: 24px;

    &.hide-mobile {
      @media (max-width: 1023px) {
        display: none;
      }
    }
  }

  &__tab {
    flex: 1 1 auto;
    text-align: center;
    cursor: pointer;
    align-self: stretch;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    color: #9e9e9e;
    min-height: 48px;
    padding: 0 16px;
    text-decoration: none;
    transition: all 0.15s ease-in-out;
    white-space: nowrap;
    border-bottom: 3px solid transparent;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }

    &.is-active {
      color: #2491e7ff;
      border-bottom: 3px solid #2491e7ff;
      opacity: 1;
    }
  }

  &__select {
    display: none;
    margin-bottom: 24px;
    @media (max-width: 1023px) {
      display: block;
    }
  }

  &--simple {
    .ui-tabs__nav {
      gap: 32px;
      margin-bottom: 16px;
    }

    .ui-tabs__tab {
      flex: initial;
      padding: 0px;
      border: none;
      min-height: 0px;
    }
  }
}
</style>
